var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "page-header",
        {
          staticClass: "scholarship-attendence__page-header",
          attrs: { page: _vm.pageHeaderConfig }
        },
        [
          _c(
            "div",
            { staticClass: "d-flex justify-content-end" },
            [
              _c("action-button", {
                attrs: {
                  i: "fas fa-search",
                  text: "Ver Información de PEI",
                  variant:
                    "outline-success scholarship-attendence__action-button"
                },
                on: {
                  click: function($event) {
                    return _vm.goToPeiInformation()
                  }
                }
              }),
              _vm.showApproveAssistance
                ? _c("action-button", {
                    attrs: {
                      i: "fas fa-check",
                      text: "Aprobar Asistencia",
                      variant: "success ml-3"
                    },
                    on: {
                      click: function($event) {
                        return _vm.onApproveAssistanceHandler()
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _c("filter-manager", {
        ref: "attendanceFilterRef",
        staticClass: "mb-4 scholarship-attendence__filter-manager",
        attrs: { filters: _vm.filterManagerConfig },
        on: {
          academicYear: _vm.onChangeAcademicYear,
          search: _vm.onSearchHandler
        },
        scopedSlots: _vm._u([
          {
            key: "header_advanced",
            fn: function() {
              return [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col d-flex justify-content-end" },
                    [
                      _c("drop-down", {
                        attrs: {
                          items: _vm.handlerFilters,
                          title:
                            _vm.handlerFilters[_vm.handlerFilterSelected].label,
                          variant: "rounded-dark"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.filtersSelected,
          callback: function($$v) {
            _vm.filtersSelected = $$v
          },
          expression: "filtersSelected"
        }
      }),
      _vm.result.data.length > 0 &&
      (_vm.handlerFilterSelected == _vm.handlerFilterEnum.paymentManagement ||
        _vm.handlerFilterSelected == _vm.handlerFilterEnum.progress ||
        _vm.handlerFilterSelected == _vm.handlerFilterEnum.expiration)
        ? _c("div", { staticClass: "row mt-4 m-0 mb-n4" }, [
            _c(
              "div",
              {
                staticClass: "col d-flex justify-content-end align-items-center"
              },
              [
                _c(
                  "span",
                  { staticClass: "mr-2 color-gray-7 font-weight-bold font-14" },
                  [_vm._v(" Seleccionar Todos ")]
                ),
                _c("check-box", {
                  staticClass: "w-auto",
                  model: {
                    value: _vm.allSelected,
                    callback: function($$v) {
                      _vm.allSelected = $$v
                    },
                    expression: "allSelected"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _c("custom-separator", {
        staticClass: "pt-3 my-4",
        attrs: { text: "Resultado de Asistencias" }
      }),
      _vm.result.data.length === 0 ? _c("result-not-found") : _vm._e(),
      _vm._l(_vm.result.data, function(item, index) {
        return _c(
          "div",
          { key: `attendance-result-${index}` },
          [
            _c(
              "validation-observer",
              {
                ref: "sectionFormRef",
                refInFor: true,
                attrs: { novalidate: "", tag: "form" }
              },
              [
                _c(
                  "callout",
                  {
                    staticClass: "mb-3 callout__extended",
                    attrs: {
                      "border-color": _vm.getColor(
                        item.assistanceApprovalStatusCd
                      ),
                      controlled: true,
                      "has-toggle":
                        _vm.handlerFilterSelected ==
                          _vm.handlerFilterEnum.paymentManagement ||
                        _vm.handlerFilterSelected ==
                          _vm.handlerFilterEnum.progress ||
                        _vm.handlerFilterSelected ==
                          _vm.handlerFilterEnum.findings ||
                        _vm.handlerFilterSelected ==
                          _vm.handlerFilterEnum.expiration,
                      opened: item.isOpen
                    },
                    on: {
                      "click:open": function($event) {
                        return _vm.onOpenDetails(item, index)
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "edition",
                          fn: function() {
                            return [
                              _c("div", { staticClass: "bg-gray p-2" }, [
                                _c(
                                  "div",
                                  { staticClass: "bg-white rounded" },
                                  [
                                    item.openedSection ==
                                    _vm.additionalSectionEnum.DOCUMENT_PAYROLL
                                      ? _c(
                                          "div",
                                          { staticClass: "mx-4 pt-3" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "row mb-3" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "col" },
                                                  [
                                                    _c("icon-view", {
                                                      attrs: {
                                                        icon:
                                                          "fa fa-file-invoice",
                                                        "icon-background":
                                                          "#fff",
                                                        "icon-color": "#2DB782",
                                                        "icon-size": "16px",
                                                        title:
                                                          "Documentar Nómina"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "row pb-3" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "col-md-2" },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function({
                                                              errors
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "custom-date-picker",
                                                                  {
                                                                    staticClass:
                                                                      "custom-date-picker",
                                                                    attrs: {
                                                                      "custom-error-msg":
                                                                        "Campo requerido.",
                                                                      disabled:
                                                                        _vm
                                                                          .model
                                                                          .payrollDateReadonly,
                                                                      error:
                                                                        errors[0],
                                                                      label:
                                                                        "Fecha de Nómina:",
                                                                      "max-date": new Date(),
                                                                      placeholder:
                                                                        "DD/MM/YYYY"
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .model
                                                                          .payrollDate,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.model,
                                                                          "payrollDate",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "model.payrollDate"
                                                                    }
                                                                  }
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "col-md-2" },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function({
                                                              errors
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "custom-date-picker",
                                                                  {
                                                                    staticClass:
                                                                      "custom-date-picker",
                                                                    attrs: {
                                                                      "custom-error-msg":
                                                                        "Campo requerido.",
                                                                      disabled:
                                                                        _vm
                                                                          .model
                                                                          .receivedDateReadonly,
                                                                      error:
                                                                        errors[0],
                                                                      label:
                                                                        "Fecha de Recibido:",
                                                                      "max-date": new Date(),
                                                                      placeholder:
                                                                        "DD/MM/YYYY"
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .model
                                                                          .receiveDate,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.model,
                                                                          "receiveDate",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "model.receiveDate"
                                                                    }
                                                                  }
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "col-md-2" },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function({
                                                              errors
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "custom-drop-down",
                                                                  {
                                                                    attrs: {
                                                                      "custom-error-msg":
                                                                        "Campo requerido.",
                                                                      error:
                                                                        errors[0],
                                                                      fieldkey:
                                                                        "id",
                                                                      fieldname:
                                                                        "name",
                                                                      label:
                                                                        "Recibido:",
                                                                      options:
                                                                        _vm.filterPayRoll,
                                                                      placeholder:
                                                                        "Seleccione"
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .model
                                                                          .receive,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.model,
                                                                          "receive",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "model.receive"
                                                                    }
                                                                  }
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "col-md-2" },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function({
                                                              errors
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "custom-input",
                                                                  {
                                                                    attrs: {
                                                                      "custom-error-msg":
                                                                        "Campo requerido.",
                                                                      error:
                                                                        errors[0],
                                                                      label:
                                                                        "Asistencia:",
                                                                      type:
                                                                        "number"
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .model
                                                                          .assistance,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.model,
                                                                          "assistance",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "model.assistance"
                                                                    }
                                                                  }
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-md-4 pt-4 doc-payroll-action"
                                                  },
                                                  [
                                                    _c(
                                                      "action-button",
                                                      {
                                                        attrs: {
                                                          i:
                                                            "fas fa-times-circle",
                                                          variant:
                                                            "outline-danger btn-cancel danger m-2 pl-4 pr-4 scholarship-attendence__action-button"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.onCancelDocPayrollHandler(
                                                              index
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v(" Cancelar ")]
                                                    ),
                                                    _c(
                                                      "action-button",
                                                      {
                                                        attrs: {
                                                          i: "fas fa-check",
                                                          variant:
                                                            "success pl-4 pr-4 scholarship-attendence__action-button"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.onConfirmHandler(
                                                              index
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v(" Confirmar ")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    item.openedSection ==
                                    _vm.additionalSectionEnum
                                      .DENEGATE_ASSISTANCE
                                      ? _c(
                                          "div",
                                          [
                                            _c("additional-section", {
                                              attrs: {
                                                "assistance-summaries-related":
                                                  _vm.model
                                                    .assistanceSummariesRelated,
                                                "assistance-summary-id":
                                                  item.assistanceSummaryId,
                                                "chk-title":
                                                  "Denegar Pagos Adicionales",
                                                "dd-title":
                                                  "Razón de Denegación:",
                                                icon: "fas fa-times-circle",
                                                "icon-background": "#d7383f",
                                                "icon-color": "#fff",
                                                index: index,
                                                "message-error":
                                                  "Favor seleccionar uno o varios periodos para completar el proceso de Denegar pagos adicionales.",
                                                options:
                                                  _vm.model.complianceReasons,
                                                "section-title":
                                                  "Denegar Asistencia",
                                                "show-status-indicator": true
                                              },
                                              on: {
                                                "on-cancel": function($event) {
                                                  return _vm.onCancelDenegateHandler(
                                                    index
                                                  )
                                                },
                                                "on-confirm":
                                                  _vm.onSaveDenegateHandler
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    item.openedSection ==
                                    _vm.additionalSectionEnum.ADDITIONAL_PAYMENT
                                      ? _c("additional-payment", {
                                          on: {
                                            "on-cancel": function($event) {
                                              return _vm.onCancelAdditionalPayment(
                                                index
                                              )
                                            },
                                            "on-confirm": function($event) {
                                              return _vm.onConfirmAdditionalPayment(
                                                index,
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    item.openedSection ==
                                    _vm.additionalSectionEnum.MANUAL_ADJUSTMENT
                                      ? _c("manual-adjustment", {
                                          attrs: {
                                            "assistance-summary-id":
                                              item.assistanceSummaryId,
                                            "cost-total-amount":
                                              item.costTotalAmt || 0,
                                            "has-manual-adjustment":
                                              item.manualAdjustmentAmt,
                                            index: index,
                                            "manual-amount":
                                              item.manualAdjustmentAmt || 0,
                                            "reason-comment":
                                              item.manualAdjustmentDescription,
                                            "reason-selected":
                                              item.manualAdjustmentReasonCd !=
                                              null
                                                ? {
                                                    id:
                                                      item.manualAdjustmentReasonCd,
                                                    name:
                                                      item.manualAdjustmentReasonName
                                                  }
                                                : null,
                                            reasons:
                                              _vm.model.adjustmentReasons,
                                            "total-attended-amount":
                                              item.totalAttendedAmt || 0
                                          },
                                          on: {
                                            "on-cancel": function($event) {
                                              return _vm.onCancelManualAdjustment(
                                                index
                                              )
                                            },
                                            "on-confirm":
                                              _vm.onSaveManualAdjustment,
                                            "on-delete":
                                              _vm.onDeleteManualAdjustment
                                          }
                                        })
                                      : _vm._e(),
                                    item.openedSection ==
                                    _vm.additionalSectionEnum
                                      .PAYMENT_RELATIONSHIP
                                      ? _c("payment-relationship", {
                                          attrs: {
                                            "assistance-summary-id":
                                              item.assistanceSummaryId,
                                            "student-sie-id": item.studentSieId
                                          },
                                          on: {
                                            "on-cancel": function($event) {
                                              return _vm.onCancelPaymentRelatinship(
                                                index
                                              )
                                            },
                                            "on-refresh":
                                              _vm.onRefreshPaymentRelationshipHandler
                                          }
                                        })
                                      : _vm._e(),
                                    item.openedSection ==
                                    _vm.additionalSectionEnum.FOLLOW_UP
                                      ? _c(
                                          "div",
                                          [
                                            _c("additional-section", {
                                              attrs: {
                                                "assistance-summaries-related":
                                                  _vm.model
                                                    .assistanceSummariesRelated,
                                                "assistance-summary-id":
                                                  item.assistanceSummaryId,
                                                "chk-title":
                                                  "Documentar Comentarios Adicionales",
                                                "dd-title": "Categoría",
                                                icon: "fas fa-comment",
                                                "icon-background": "#fff",
                                                "icon-color": "#2DB782",
                                                index: index,
                                                "message-error":
                                                  "Favor seleccionar uno o varios periodos para completar el proceso de Documentar comentarios adicionales.",
                                                options:
                                                  _vm.model.followUpCategories,
                                                "section-title": "Comentario"
                                              },
                                              on: {
                                                "on-cancel": function($event) {
                                                  return _vm.onCancelFollowUp(
                                                    index
                                                  )
                                                },
                                                "on-confirm": _vm.onSaveFollowUp
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    item.openedSection ==
                                    _vm.additionalSectionEnum.TABS
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "custom-tab",
                                              {
                                                attrs: {
                                                  "content-class": "mt-3",
                                                  "nav-class":
                                                    "custom-nav-container",
                                                  "no-nav-style": true
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.onActiveTab(
                                                      item,
                                                      $event
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: item.mainTabModel,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "mainTabModel",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.mainTabModel"
                                                }
                                              },
                                              [
                                                _c(
                                                  "custom-tab-item",
                                                  {
                                                    attrs: {
                                                      active: "",
                                                      lazy: "",
                                                      title:
                                                        "Información Adicional"
                                                    }
                                                  },
                                                  [
                                                    _c("additional-info", {
                                                      attrs: {
                                                        "is-thrpy-service":
                                                          (_vm.isTherapyService(
                                                            item.peiAnalysisServiceId
                                                          ) &&
                                                            _vm.thrpyInfo) ||
                                                          _vm.handlerFilterSelected !==
                                                            _vm
                                                              .handlerFilterEnum
                                                              .findings,
                                                        "thrpy-info":
                                                          _vm.thrpyInfo || {},
                                                        "transportation-info":
                                                          _vm.transportationInfo ||
                                                          {},
                                                        value: item
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm.canShowTab
                                                  ? _c(
                                                      "custom-tab-item",
                                                      {
                                                        attrs: {
                                                          active:
                                                            _vm.mainTabsEnum
                                                              .ASSISTANCE_DETAILS ===
                                                            item.mainTabModel,
                                                          lazy: "",
                                                          title:
                                                            "Detalles de Asistencia"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.onSelectTabAssistanceDetails(
                                                              index,
                                                              item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "assistance-details",
                                                          {
                                                            attrs: {
                                                              "adjust-assistances":
                                                                item.adjustAssistances,
                                                              "adjust-periods":
                                                                item.adjustPeriods,
                                                              "assistance-service":
                                                                item.assistanceService,
                                                              "assistance-summary": item,
                                                              "normal-assistances":
                                                                item.normalAssistances,
                                                              "selected-period":
                                                                item.selectedPeriod,
                                                              "show-assistance-service": _vm.showAssistanceService(
                                                                item
                                                              )
                                                            },
                                                            on: {
                                                              "on-select-adjusment-period": function(
                                                                $event
                                                              ) {
                                                                return _vm.onSelectAdjustmentPeriodHandler(
                                                                  index,
                                                                  item,
                                                                  $event
                                                                )
                                                              },
                                                              "on-update-milleage-companion": function(
                                                                $event
                                                              ) {
                                                                return _vm.onUpdateMillageCompanion(
                                                                  index,
                                                                  item
                                                                )
                                                              }
                                                            }
                                                          }
                                                        ),
                                                        _vm.showAssistanceVisit(
                                                          item.payrollReceiveTypeId
                                                        )
                                                          ? _c(
                                                              "assistance-visit",
                                                              {
                                                                attrs: {
                                                                  rows:
                                                                    item.assistanceVisitResult
                                                                }
                                                              }
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.canShowTab
                                                  ? _c(
                                                      "custom-tab-item",
                                                      {
                                                        attrs: {
                                                          active:
                                                            _vm.mainTabsEnum
                                                              .PAYMENTS ===
                                                            item.mainTabModel,
                                                          lazy: "",
                                                          title: "Pagos"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.onSelectTabPayment(
                                                              index,
                                                              item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("payment", {
                                                          attrs: {
                                                            "additional-payments":
                                                              item.additionalPayments ||
                                                              [],
                                                            "payment-relationship":
                                                              _vm.relationshipPayment,
                                                            status:
                                                              item.assistanceApprovalStatusCd,
                                                            value:
                                                              item.payment || {}
                                                          },
                                                          on: {
                                                            "on-delete":
                                                              _vm.onDeleteAdditionalPaymentHandler,
                                                            "on-delete-relation": function(
                                                              $event
                                                            ) {
                                                              return _vm.onDeleteRelationHandler(
                                                                item,
                                                                $event
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "custom-tab-item",
                                                  {
                                                    attrs: {
                                                      active:
                                                        _vm.mainTabsEnum
                                                          .HISTORY ===
                                                        item.mainTabModel,
                                                      lazy: "",
                                                      title: "Historial"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.onSelectHistoryTab(
                                                          index,
                                                          item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    item.showHistory
                                                      ? _c("history", {
                                                          attrs: {
                                                            id: _vm.isFinding
                                                              ? item.eligibleStudentId
                                                              : item.assistanceSummaryId,
                                                            "default-category": _vm.isFinding
                                                              ? _vm
                                                                  .assistanceEventTypeEnum
                                                                  .Hallazgo
                                                              : null,
                                                            "hide-filter":
                                                              _vm.isFinding
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ],
                                                  1
                                                ),
                                                item.hasCompliance &&
                                                _vm.canShowTab
                                                  ? _c(
                                                      "custom-tab-item",
                                                      {
                                                        attrs: {
                                                          lazy: "",
                                                          title:
                                                            "Informe de Progreso"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.onSelectTabProgressReport(
                                                              index,
                                                              item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("progress-inform", {
                                                          attrs: {
                                                            value:
                                                              item.progressReport ||
                                                              {}
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    item.openedSection ==
                                    _vm.additionalSectionEnum.FINDING_COMMENT
                                      ? _c(
                                          "div",
                                          [
                                            _c("finding-comment", {
                                              on: {
                                                "on-cancel": function($event) {
                                                  return _vm.onCancelFindingCommentHandler(
                                                    index,
                                                    item
                                                  )
                                                },
                                                "on-confirm": function($event) {
                                                  return _vm.onSaveFindingCommentHandler(
                                                    index,
                                                    item,
                                                    $event
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _vm.handlerFilterSelected ==
                      _vm.handlerFilterEnum.paymentManagement ||
                    _vm.handlerFilterSelected ==
                      _vm.handlerFilterEnum.progress ||
                    _vm.handlerFilterSelected ==
                      _vm.handlerFilterEnum.expiration
                      ? _c("row-standard", {
                          attrs: {
                            "general-tab-index": item.mainTabModel,
                            index: index,
                            "show-remaing-days":
                              _vm.handlerFilterSelected ==
                              _vm.handlerFilterEnum.expiration
                                ? true
                                : false,
                            value: item
                          },
                          on: {
                            "additional-payment": _vm.onAdditionalPayment,
                            "certification-document":
                              _vm.onCertificationDocumentHandler,
                            "denegate-assistance":
                              _vm.onDenegateAssistanceHandler,
                            "document-payroll": _vm.onDocumentPayrollHandler,
                            "follow-up": _vm.onFollowUpAssitance,
                            "manual-adjustment": _vm.onManualAdjustment,
                            "on-select-tab-index": function($event) {
                              return _vm.onSelectTabIndexHandler(
                                index,
                                item,
                                $event
                              )
                            },
                            "payment-relationship": _vm.onPaymentRelationship,
                            "restart-payroll": _vm.restartPayrollHandler,
                            "restart-status": _vm.restartStatusHandler
                          }
                        })
                      : _vm._e(),
                    _vm.handlerFilterSelected == _vm.handlerFilterEnum.findings
                      ? _c("row-finding", {
                          attrs: { value: item },
                          on: {
                            "on-set-finding-comment": function($event) {
                              return _vm.onSetFindingCommentHandler(index)
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                item.sieSiblings && item.sieSiblings.length > 0
                  ? _c(
                      "div",
                      [
                        _c("error", {
                          staticStyle: {
                            background: "#FFEDBB",
                            border: "none",
                            color: "#AF7304 !important",
                            position: "relative",
                            bottom: "17px"
                          },
                          attrs: {
                            icon: "fa-info-circle",
                            "is-alert-mode": "",
                            message: `Este estudiante tiene hermanos que actualmente cuentan con BECA: ${item.sieSiblings}`
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                false
                  ? _c(
                      "div",
                      { staticClass: "bg-secondary-19 p-2 rounded mt-n3 mb-3" },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "color-secondary-20 font-14 font-weight-normal"
                          },
                          [
                            _c(
                              "p",
                              { staticClass: "fas fa-bell-exclamation icon" },
                              [
                                _vm._v(
                                  " Los records Educativos Públicos deben estar marcados analizados para poder aprobar los pagos. "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                item.isNotEligible
                  ? _c(
                      "div",
                      { staticClass: "bg-secondary-18 p-2 rounded mt-n3 mb-3" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "color-secondary-21 font-14 font-weight-normal d-flex align-items-center"
                          },
                          [
                            _c("em", {
                              staticClass: "fas fa-bell-exclamation pl-1"
                            }),
                            _c(
                              "div",
                              { staticClass: "ml-2 no-eligible-message pl-2" },
                              [
                                _vm._v(
                                  " El estudiante no es elegible para Becas de Transportación de acuerdo a los PEI’s firmados en el sistema. "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                item.invalidTotalAmount
                  ? _c(
                      "div",
                      { staticClass: "bg-secondary-19 p-2 rounded mt-n3 mb-3" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "color-secondary-21 font-14 font-weight-normal d-flex align-items-center"
                          },
                          [
                            _c("em", {
                              staticClass:
                                "fas fa-bell-exclamation pl-1 color-secondary-20"
                            }),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "ml-2 no-eligible-message pl-2 color-secondary-20"
                              },
                              [
                                _vm._v(
                                  " El record de pago no cuenta con un total valido para ser aprobado. "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                item.invalidApprovePayment
                  ? _c(
                      "div",
                      { staticClass: "bg-secondary-19 p-2 rounded mt-n3 mb-3" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "color-secondary-21 font-14 font-weight-normal d-flex align-items-center"
                          },
                          [
                            _c("em", {
                              staticClass:
                                "fas fa-bell-exclamation pl-1 color-secondary-20"
                            }),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "ml-2 no-eligible-message pl-2 color-secondary-20"
                              },
                              [
                                _vm._v(
                                  " Los records Educativos Públicos deben estar marcados analizados para poder aprobar los pagos. "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            ),
            item.eligibleFlag
              ? _c(
                  "div",
                  { staticClass: "bg-secondary-18 p-2 rounded mt-n3 mb-3" },
                  [
                    _c("em", {
                      staticClass:
                        "fa fa-bell-exclamation color-secondary-21 mr-2"
                    }),
                    _c(
                      "span",
                      {
                        staticClass:
                          "color-secondary-21 font-14 font-weight-normal"
                      },
                      [_vm._v(" " + _vm._s(item.eligibleFlagDescription) + " ")]
                    )
                  ]
                )
              : _vm._e(),
            item.errorFlag
              ? _c(
                  "div",
                  { staticClass: "bg-secondary-19 p-2 rounded mt-n3 mb-3" },
                  [
                    _c("em", {
                      staticClass: "fa fa-times-circle color-secondary-20 mr-2"
                    }),
                    _c(
                      "span",
                      {
                        staticClass:
                          "color-secondary-20 font-14 font-weight-normal"
                      },
                      [_vm._v(" " + _vm._s(item.errorDescription) + " ")]
                    )
                  ]
                )
              : _vm._e(),
            item.notEligibleStudent
              ? _c(
                  "div",
                  { staticClass: "bg-secondary-19 p-2 rounded mt-n3 mb-3" },
                  [_vm._m(0, true)]
                )
              : _vm._e()
          ],
          1
        )
      }),
      _vm.showPagination
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-1 pt-3" },
              [
                _c("custom-drop-down", {
                  attrs: {
                    clearable: false,
                    fieldkey: "id",
                    fieldname: "name",
                    options: _vm.pagingList
                  },
                  on: { input: _vm.onSelectedPagingHandler },
                  model: {
                    value: _vm.selectedPaging,
                    callback: function($$v) {
                      _vm.selectedPaging = $$v
                    },
                    expression: "selectedPaging"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-11" },
              [
                _c("pagination", {
                  attrs: {
                    data: _vm.result,
                    "page-size": _vm.pageSize,
                    "show-text": true
                  },
                  on: { "pagination-go-page": _vm.goToPageHandler }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "color-secondary-21 font-14 font-weight-normal d-flex align-items-center"
      },
      [
        _c("em", { staticClass: "fa fa-times-circle color-secondary-20 mr-2" }),
        _c(
          "div",
          { staticClass: "color-secondary-20 font-14 font-weight-normal" },
          [
            _vm._v(
              " No es posible aprobar la(s) asitencia(s), ya que cuenta con estudiante(s) no elegible(s) para Becas de Transportación de acuerdo a los PEI’s firmados en el sistema. "
            )
          ]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }